import { employeeApi } from 'container/employeeApi';
import { employeeMapper } from 'container/employeeMapper';
import { EmployeeRepository } from 'repository/EmployeeRepository';

export const employeeRepository = new EmployeeRepository(employeeApi, employeeMapper);
